import { createContext, useContext, useMemo } from 'react';
import { useParams } from 'react-router';
import { LazyOutlet } from 'design-system/atoms/spinner-suspense';
import { pathSiteMonitoringVms } from '../../utils/path';

export interface VMSContextType {
  vmsId?: string;
  baseUrl: string;
  orgId: string;
  siteId: string;
}

export const VMSContext = createContext<VMSContextType>({
  vmsId: '',
  baseUrl: '',
  orgId: '',
  siteId: '',
});

export default function ContextVms() {
  const {
    vmsId: paramsVmsId,
    siteId,
    insightId,
    orgId: paramsOrgId,
    vmsConfigId: paramsVmsConfigId,
  } = useParams();

  const vmsId = paramsVmsId ?? paramsVmsConfigId;
  const orgId = paramsOrgId ?? insightId;
  if (typeof orgId !== 'string') {
    throw new Error('Could not find orgId in params');
  }
  if (typeof siteId !== 'string') {
    throw new Error('Could not find siteId in params');
  }
  const baseUrl = pathSiteMonitoringVms({ orgId, siteId });

  const contextValue = useMemo(
    () => ({ vmsId, baseUrl, orgId, siteId }),
    [vmsId, baseUrl, orgId, siteId]
  );
  return (
    <VMSContext.Provider value={contextValue}>
      <LazyOutlet />
    </VMSContext.Provider>
  );
}

export function useContextVMS() {
  const context = useContext(VMSContext);
  if (!context) {
    throw new Error('useContextVMS must be used within a VMSContext.Provider');
  }
  return context;
}
